import SelectRecommenderModal from './select-recommender-modal.view';

export default SelectRecommenderModal;
